import { WELCOME_SEEN_PARAM } from './welcomeSplash';

interface HasSeenWelcomeParams {
  search: string;
}

export function hasSeenWelcome({ search }: HasSeenWelcomeParams) {
  return new URLSearchParams(search).get(WELCOME_SEEN_PARAM) === 'true';
}
